import { Component } from 'react';
import { withRouter } from 'react-router';

import { withSteps } from 'Common/StepComponent';

import { PowerSchoolExportConfigurationStep } from './components/PowerSchoolExportConfigurationStep/PowerSchoolExportConfigurationStep';
import { PowerSchoolExportExportStep } from './components/PowerSchoolExportExportStep/PowerSchoolExportExportStep';

class PowerSchoolExportContainer extends Component {
  static title = 'PowerSchool Export';
}

export const PowerSchoolExport = withRouter(
  withSteps([PowerSchoolExportConfigurationStep, PowerSchoolExportExportStep])(
    PowerSchoolExportContainer
  )
);



// WEBPACK FOOTER //
// ./src/pages/powerschoolintegration/powerschoolexport/PowerSchoolExport.js